import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsTableFilters = _resolveComponent("EventsTableFilters")!
  const _component_EventsBaseTable = _resolveComponent("EventsBaseTable")!

  return (_openBlock(), _createBlock(_component_EventsBaseTable, {
    title: "График планируемых межрегиональных мероприятий на ближайшие 15 дней",
    legend: _ctx.significantEventLegend,
    columns: _ctx.columns,
    storePaths: _ctx.storePaths,
    params: _ctx.tableParams,
    eventConfigs: _ctx.eventConfigs,
    defaultSort: _ctx.defaultSort
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_EventsTableFilters, {
        hideSubjectFilter: _ctx.hideSubjectFilter,
        hideCountryFilter: _ctx.hideCountryFilter,
        onChange: _ctx.onFilterChange
      }, null, 8, ["hideSubjectFilter", "hideCountryFilter", "onChange"])
    ]),
    numberSuffix: _withCtx(({ row }) => [
      (row?.significantFlag)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("*")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["legend", "columns", "storePaths", "params", "eventConfigs", "defaultSort"]))
}